import React, { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import "./profileSidebar.scss";

import {
    Box,
    Avatar,
    IconButton,
    TextField,
    MenuItem,
    Button,
} from "@mui/material";
import { ReactComponent as DeleteIcon } from "../../assets/dashboardIcons/deleteIcon.svg";
import { useDispatch, useSelector } from "react-redux";
import { fetchCompanyUser, fetchUserRoles, updateCompanyUser } from "../../features/companyUser/companyUserThunk";
import { selectIsRolesLoading, selectRoles } from "../../features/companyUser/companyUserSlice";
import { getUserProfile, UpdateUserProfile } from "../../features/auth/authThunk";
import { fetchSingleCompany } from "../../features/company/companyThunk";
import { selectSingleCompany } from "../../features/company/companySlice";

const schema = yup.object().shape({
    name: yup.string().required("Nome collaboratore is required"),
    email: yup.string().email("Invalid email").required("Email is required"),
    profileType: yup.string().required("Tipo di profilo is required"),
    company: yup.string(),
    creationDate: yup.string().required("Data creazione utente is required"),
    profile: yup.mixed().notRequired()
});

const ProfileSidebar = () => {
    const singleCompany = useSelector(selectSingleCompany);
    const {
        control,
        handleSubmit,
        setValue,
        register,
        formState: { errors },
        reset,
    } = useForm({
        resolver: yupResolver(schema),
    });

    const dispatch = useDispatch();
    const user = useSelector((state) => state?.auth?.user);
    const roles = useSelector(selectRoles);
    const isRolesLoading = useSelector(selectIsRolesLoading);

    const [profileImage, setProfileImage] = useState(null);

    useEffect(() => {
        register("profile");
    }, [register]);

    useEffect(() => {
        dispatch(fetchUserRoles());
    }, [dispatch]);

    useEffect(() => {
        dispatch(getUserProfile(user?.id));
    }, [dispatch]);

    useEffect(() => {
        if (user?.company_id) {
            dispatch(fetchSingleCompany(user.company_id));
        }
    }, [dispatch, user]);

    useEffect(() => {
        if (user) {
            reset({
                name: user.name || "",
                email: user.email || "",
                profileType: user.role_id || "",
                company: singleCompany?.name || "",
                creationDate: user.created_at ? user.created_at.substring(0, 10) : "",
            });
            if (user.profile) {
                const fullProfileImage = user.profile.startsWith("http")
                    ? user.profile
                    : `https://api.vivon.it/storage/${user.profile}`;
                setProfileImage(fullProfileImage);
            }
        }
    }, [user, singleCompany, reset]);


    const handleImageUpload = (event) => {
        const file = event.target.files[0];
        if (file) {
            const imageUrl = URL.createObjectURL(file);
            setProfileImage(imageUrl);
            setValue("profile", file); // update the form state
        }
    };

    const onSubmit = (data) => {
        const formData = new FormData();
        formData.append("name", data.name);
        formData.append("email", data.email);
        formData.append("profileType", data.profileType);
        formData.append("company", data.company);
        formData.append("creationDate", data.creationDate);

        if (data.profile instanceof File) {
            formData.append("profile", data.profile);
        }

        dispatch(UpdateUserProfile({ userId: user?.id, userData: formData }))
            .then((response) => {
                if (response.meta.requestStatus === "fulfilled") {
                    dispatch(getUserProfile(user?.id));
                    console.log("User profile updated successfully");
                } else {
                    console.error("Update failed", response);
                }
            })
            .catch((err) => {
                console.error("Error updating profile:", err);
            });
    };

    return (
        <Box className="accountBox">
            <p className="accountBox__title">Il tuo account</p>
            <div className="accountBox__detail">
                <div className="accountBox__detailText">
                    <label htmlFor="upload-photo">
                        <input
                            type="file"
                            id="upload-photo"
                            accept="image/*"
                            style={{ display: "none" }}
                            onChange={handleImageUpload}
                        />
                        <Avatar
                            className="accountBox__avatar"
                            src={profileImage}
                            sx={{ cursor: "pointer", width: 100, height: 100 }}
                        >
                            {!profileImage && "Carica foto"}
                        </Avatar>
                    </label>
                    <div className="accountBox__avatar-texts">
                        <p className="accountBox__avatar-title">{user?.name || "N/A"}</p>
                        <p className="accountBox__avatar-subTitle">{user?.email || "N/A"}</p>
                        <p className="accountBox__avatar-subTitle">{user?.role_id || "N/A"}</p>
                    </div>
                </div>
                <IconButton size="small" color="error">
                    <DeleteIcon />
                </IconButton>
            </div>

            <form className="AziendaFrom accountForm" onSubmit={handleSubmit(onSubmit)}>
                <div className="AziendaFrom__inner">
                    <Controller
                        name="name"
                        control={control}
                        render={({ field }) => (
                            <TextField
                                className="customTextBox"
                                {...field}
                                label="Nome collaboratore"
                                fullWidth
                                margin="normal"
                                error={!!errors.name}
                                helperText={errors.name?.message}
                            />
                        )}
                    />
                    <Controller
                        name="email"
                        control={control}
                        render={({ field }) => (
                            <TextField
                                className="customTextBox"
                                {...field}
                                label="Email"
                                fullWidth
                                margin="normal"
                                error={!!errors.email}
                                helperText={errors.email?.message}
                            />
                        )}
                    />
                    <Controller
                        name="profileType"
                        control={control}
                        render={({ field }) => (
                            <TextField
                                className="customTextBox"
                                value={user?.role_id}
                                label="Tipo di profilo"
                                fullWidth
                                margin="normal"
                                disabled
                            />

                            // <TextField
                            //     className="customTextBox"
                            //     {...field}
                            //     label="Tipo di profilo"
                            //     fullWidth
                            //     margin="normal"
                            //     error={!!errors.profileType}
                            //     helperText={errors.profileType?.message}
                            //     disabled
                            //     select
                            // >
                            //     {isRolesLoading ? (
                            //         <MenuItem disabled>Loading roles...</MenuItem>
                            //     ) : roles?.length > 0 ? (
                            //         roles.map((role) => (
                            //             <MenuItem key={role.id} value={role.id}>
                            //                 {role.name.charAt(0).toUpperCase() + role.name.slice(1)}
                            //             </MenuItem>
                            //         ))
                            //     ) : (
                            //         <MenuItem disabled>No roles available</MenuItem>
                            //     )}
                            // </TextField>
                        )}
                    />
                    <Controller
                        name="company"
                        control={control}
                        render={({ field }) =>
                            user?.role_id !== 'SUPERADMIN' && (
                                <TextField
                                    className="customTextBox"
                                    {...field}
                                    label="Associazione azienda"
                                    fullWidth
                                    margin="normal"
                                    error={!!errors.company}
                                    helperText={errors.company?.message}
                                    value={singleCompany?.name || ""}
                                    disabled
                                />
                            )
                        }
                    />
                    <Controller
                        name="creationDate"
                        control={control}
                        render={({ field }) => (
                            <TextField
                                className="customTextBox"
                                {...field}
                                label="Data creazione utente"
                                fullWidth
                                margin="normal"
                                error={!!errors.creationDate}
                                helperText={errors.creationDate?.message}
                                disabled
                            />
                        )}
                    />
                    <div className="btnPart1">
                        <Button type="submit" variant="contained">
                            Salva dati
                        </Button>
                    </div>
                </div>
            </form>
        </Box>
    );
};

export default ProfileSidebar;